import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import { Alert, Skeleton } from 'antd';

import AssistanceRequestAmountInfo from '@/components/AssistanceRequestDetail/Amount';
import AssistanceRequestDetail from '@/components/AssistanceRequestDetail/Details';
import { useQueryAssistanceRequestDetail } from '@/hooks/useQueryAssistanceRequestDetail';
import useGlobalConfig from '@/store/global';

const AssistanceRequestFormShow = () => {
  const { assistanceRequestId } = useParams();
  const { program } = useGlobalConfig();
  const [searchParams] = useSearchParams();
  const showSubmitted = searchParams.get('submitted') === 'true';

  const { data = {}, isLoading } = useQueryAssistanceRequestDetail(assistanceRequestId);
  const alertMessage = data?.notice_success_after_create;

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 10 }} />;
  }

  return (
    <>
      <div className="mx-auto">
        {showSubmitted && alertMessage && (
          <Alert className="mb-6" message={alertMessage} type="success" />
        )}
        <AssistanceRequestAmountInfo data={data} program={program.name} />
        <AssistanceRequestDetail data={data} program={program.name} />
      </div>
    </>
  );
};

export default AssistanceRequestFormShow;
